// Constants
export const CURRENCY_LOCALES = {
    'USD': ['en_US'],
    'CAD': ['en_CA'],
    '£': ['en_GB'],
    '€': ['en_EU', 'es_ES', 'de_DE'],
    '₹': ['en_IN'],
};

export const DEFAULT_LOCALE = 'en_US';
export const DEFAULT_CURRENCY = 'USD';

// Utility functions
export const normalizeLocale = (locale) => {
    if (!locale || !locale.includes('-')) return locale;
    const [language, region] = locale.split('-');
    return `${language.toLowerCase()}_${region.toUpperCase()}`;
};

export const findCurrencySymbol = (locale) => {
    return Object.keys(CURRENCY_LOCALES).find(symbol =>
        CURRENCY_LOCALES[symbol].includes(locale)
    ) || DEFAULT_CURRENCY;
};

export const getStoreTemplateAttributes = () => {
    const element = document.querySelector('store-template');
    return {
        locale: element?.getAttribute('locale'),
        spi: element?.getAttribute('spi'),
    };
};
